import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export const Guarantee = () => {
  return <section className="py-24 bg-cream relative" data-id="element-110">
      <div className="container mx-auto px-6" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto bg-white p-10 md:p-16 rounded-sm shadow-xl border border-gold-500/20 text-center relative overflow-hidden" data-id="element-112">
          {/* Decorative watermark */}
          <ShieldCheck className="absolute -right-10 -bottom-10 w-64 h-64 text-gold-500/5 pointer-events-none" data-id="element-113" />

          <div className="inline-flex items-center justify-center w-20 h-20 bg-gold-500/10 rounded-full mb-8 relative z-10" data-id="element-114">
            <ShieldCheck className="w-10 h-10 text-gold-600" data-id="element-115" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-6 relative z-10" data-id="element-116">
            GARANTÍA TOTAL DE SATISFACCIÓN (7 DÍAS)
          </h2>

          <p className="text-lg text-navy/80 leading-relaxed relative z-10 max-w-2xl mx-auto" data-id="element-117">
            Prueba el material en tu consultorio sin riesgos. Adquiere la guía
            hoy, descarga el Script Book, aplica las fichas clínicas con tus
            pacientes o lee los fundamentos teóricos. Si en los primeros 7 días
            sientes que este método no eleva el nivel de tus consultas, nos
            escribes un correo y te reembolsamos el 100% de tu dinero de manera
            inmediata. Sin preguntas complicadas. Nuestra tasa de devolución es
            menor al 1%.
          </p>
        </motion.div>
      </div>
    </section>;
};